<template>
  <v-app id="app">
    <router-view name="header" />
    <div class="main-wrapper">
      <router-view name="aside"/>
      <router-view class="root-content"/>
    </div>
    <router-view name="footer"/>
    <notifications />
  </v-app>
</template>

<script>
import Notifications from '@/components/Notifications';

export default {
  name: 'app',
  components: {
    Notifications,
  },
}
</script>
